import "./status-dot.css";

const StatusDot = ({ status, label }: {status: 'enabled' | 'disabled' | 'pending' | 'rejected', label?: string }) => {
    return (
        <div className={`status-dot-container ${label ? 'with-label': ''}`}>
            <div className={`status-dot ${status}`} />
            {label ? <span>{label}</span> : null}
        </div>
    )
}

export default StatusDot;